var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.route)?_c('div',[_vm._l((_vm.route.routeStops),function(routeStop,routeStopIndex){return _c('RouteStopMarker',{key:'routeStop-' + routeStopIndex,attrs:{"colour":_vm.colour,"route-stop":routeStop,"is-visible":_vm.isVisible,"info-window-reference":_vm.infoWindowReference}})}),(_vm.route.directions)?_c('div',_vm._l((_vm.route.directions.legs),function(leg,legIndex){return _c('GmapPolyline',{key:'leg-' + legIndex,attrs:{"path":_vm.decodedPath(leg.encodedPolyLine),"options":{
        strokeColor: _vm.colour,
        strokeWeight: 4,
        strokeOpacity: 1,
        visible: _vm.isVisible,
        zIndex: 0,
        icons: [
          {
            icon: {
              path: _vm.circleShapePath,
              fillColor: 'white',
              fillOpacity: 1,
              scale: 0.2
            },
            offset: 0,
            repeat: '10px'
          }
        ]
      }}})}),1):_vm._e(),_c('GmapPolyline',{attrs:{"path":_vm.travelledPath,"options":{
      strokeColor: _vm.colour,
      strokeWeight: 4,
      strokeOpacity: 0.7,
      visible: _vm.isVisible,
      zIndex: 10
    }}}),(!_vm.isCompletedRoute && _vm.isVisible)?_c('AssetMarker',{attrs:{"colour":_vm.colour,"position":_vm.trackableAssetLocation,"heading":_vm.trackableAssetHeading,"is-visible":_vm.isVisible,"item":_vm.item}}):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }